// i18next-extract-mark-ns-start homepage
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { frames, tabletThresholdPixels } from './styledComponents';
import { ratingData } from '../v3/ratingData';
import heartIcon from '../../../assets/headers/v4/heart.svg';
import calendarIcon from '../../../assets/headers/v4/calendar.svg';
import docIcon from '../../../assets/headers/v4/doc.svg';
import thumbIcon from '../../../assets/headers/v4/thumb.svg';

type ContainerType = {
  bigMargin?: boolean;
};
const Container = styled.div<ContainerType>`
  max-width: 1180px;
  width: 100%;
  ${(props) => props.bigMargin ? `margin: 128px ${frames.desktop};` : `margin: 64px ${frames.desktop};`};
  @media (max-width: ${tabletThresholdPixels}) {
    margin: 0px ${frames.mobile};
    width: calc(100vw - (${frames.mobile}*2));
  }
`;

const Content = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 20px 0;
  width: 100%;
  @media (max-width: ${tabletThresholdPixels}) {
    margin: 40px 0px;
    flex-direction: column;
    gap: 11px;
    padding: 0;
  }
`;

const BlockContainer = styled.div`
  max-width: 240px;
  gap: 20px;
  @media (max-width: ${tabletThresholdPixels}) {
    display: flex;
    max-width: unset;
    gap: 21px;
    align-items: flex-start;
  }
`;

const TextBlock = styled.p`
  font-size: 20px;
  text-transform: uppercase;
  @media (max-width: ${tabletThresholdPixels}) {
    font-size: 16px;
    margin: 0;
  }
`;

const Icon = styled.img`
  @media (max-width: ${tabletThresholdPixels}) {
    width: 14px;
  }
`;

const ButtonContainer = styled.div`
  /* margin-top: -80px; */
  display: flex;
  justify-content: center;
  @media (max-width: ${tabletThresholdPixels}) {
    margin-top: 0;
  }
`;

type ArgumentDataType = {
  id: string;
  icon: string;
  text: string;
  textLPCloth?: string;
  textLPDeco?: string;
  textPackage?: string;
  textLPRepair?: string;
}[];

const getArgumentsData: (_t: (_key: string, _options?: { [key: string]: any }) => string) => ArgumentDataType = (t) => [
  {
    id: 'Argument_1',
    icon: heartIcon,
    text: t('Vêtements · Déco · Sacs · Chaussures'),
    textLPCloth: t('Confiez nous tous vos vêtements'),
    textLPDeco: t('Confiez nous votre linge de maison'),
    textLPRepair: t('Artisans locaux sélectionnés avec soin'),
  },
  {
    id: 'Argument_2',
    icon: calendarIcon,
    text: t('Service par envoi de colis ou à domicile'),
    textPackage: t('Service de colis partout en France'),
  },
  {
    id: 'Argument_3',
    icon: docIcon,
    text: t('Devis en ligne en 20 secondes'),
  },
  {
    id: 'Argument_4',
    icon: thumbIcon,
    text: t('{{score}}/10 sur plus de {{numberOfReviews}} avis', { score: ratingData.scoring, numberOfReviews: ratingData.numberOfReviews }),
  },
];

type ArgumentsBannerType = {
  packagePage?: boolean;
  button?: React.ReactNode;
  landingPagePath?: string;
  landingPages?: boolean;
};

export default function ArgumentsBanner({
  packagePage, button, landingPagePath, landingPages,
}: ArgumentsBannerType) {
  const { t } = useTranslation();
  const getText = (data: ArgumentDataType[0]) => {
    if (packagePage && data.textPackage) return data.textPackage;
    if (landingPagePath === 'clothes' && data.textLPCloth) return data.textLPCloth;
    if (landingPagePath === 'deco' && data.textLPDeco) return data.textLPDeco;
    if (landingPagePath === 'repair' && data.textLPRepair) return data.textLPRepair;
    return data.text;
  };
  return (
    <Container bigMargin={landingPages}>
      <Content>
        {getArgumentsData(t).map((data) => (
          <BlockContainer key={data.id}>
            <Icon src={data.icon} alt="Icon" />
            <TextBlock>{getText(data)}</TextBlock>
          </BlockContainer>
        ))}
      </Content>
      {button && (
        <ButtonContainer>
          {button}
        </ButtonContainer>
      )}
    </Container>
  );
}

ArgumentsBanner.defaultProps = {
  landingPages: false,
  packagePage: false,
  button: null,
  landingPagePath: '',
};
